import { Controller } from "@hotwired/stimulus"

const BLANK = "blank"

export default class extends Controller {
  static targets = ["trigger", "group"]

  connect() {
    this.toggle()
  }

  toggle() {
    const value = this.triggerTarget.value || BLANK
    this.groupTargets.forEach((group) => {
      const visible = group.dataset.conditionalGroupsValues.split(" ").includes(value)
      group.classList.toggle("tw-hidden", !visible)
      group.setAttribute("aria-hidden", (!visible).toString())
      group.querySelectorAll("input, select, textarea").forEach((input) => { input.disabled = !visible })
    })
  }
}
